export default __webpack_public_path__ + "static/media/099-wine.78ecc30e.svg";